import { useState, useEffect, useRef } from 'react';
import { useTranslations } from 'next-intl';

import { BookingErrorType } from '@/types/booked-bet';

interface BookingInputTipProps {
	errorType: number;
	adjustedValue?: string;
	onTipClose: () => void;
}

const messages = {
	[BookingErrorType.IntervalRange]: 'lbl_ECPCurrentOddsCheck',
	[BookingErrorType.Minimum]: 'lbl_ECPMinOddsCheck',
	[BookingErrorType.Maximum]: 'lbl_ECPMaxOddsCheck',
};

export const BookingInputTip = ({ errorType, adjustedValue, onTipClose }: BookingInputTipProps) => {
	const t = useTranslations('General');

	const [isShowTip, setIsShowTip] = useState(false);
	const timerRef = useRef<ReturnType<typeof setTimeout>>();

	const messageKey = messages[errorType as BookingErrorType];
	const message = [
		BookingErrorType.IntervalRange, 
		BookingErrorType.Minimum, 
		BookingErrorType.Maximum
	].includes(errorType) ? t(messageKey, { X: adjustedValue }) : t(messageKey);

	useEffect(() => {
		setIsShowTip(true);

		clearTimeout(timerRef.current);
		timerRef.current = setTimeout(
			() => {
				setIsShowTip(false);
				onTipClose();
			}, 
			3000
		);
		
		return () => {
			clearTimeout(timerRef.current);
		};
	}, [errorType]);

	return isShowTip ? (
		<div 
			className="tip"
			data-open={true}
		>
			<div className="scrollbar scrollbar--tip">
				<div className="tip__content">{message}</div>
			</div>
		</div>
	) : null;
};